// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';

import RulesList from './Rules/RulesList'
import RulesElementSelectorList from './Rules/RulesElementSelectorList'

var dashboardCommonJS = require("../../js/dashboardCommon.js")
var rulesCommonJS = require("../../js/rulesCommon.js")

// DASHBOARD
const Rules = (params) => {

  useEffect(() => {             
    console.log("Reglas cargadas correctamente.")
  }, [params.update]);

  const [objRuleForm, setObjRuleForm] = useState([])  
  const [objRuleElementSelector, setObjRuleElementSelector] = useState({"categoria":"categoria0","selectId": "select0","valores": []})
  
  function gestionarVisibilidadDetalleRegla(event){         
    if ( (document.getElementById("asideDetalleRegla") !== null) && !document.getElementById("asideDetalleRegla").className.includes("hidden") && (event.target.id === "asideDetalleRegla") ){
      
      //Por la forma de renderizado del formulario seteo a "" los valores de los campos de los atributos al cerrar
      var objCamposTextoCondicion = document.getElementById("Condiciones").querySelectorAll("input[type='text']")
      for(var x=0; x < objCamposTextoCondicion.length; x++){ document.getElementById(objCamposTextoCondicion[x].id).value = "" }      
      
      document.getElementById("asideDetalleRegla").className = document.getElementById("asideDetalleRegla").className.replaceAll(" hidden","") + " hidden"
    }
  };

  function cerrarMenuLateral(){
    document.getElementById("asideDetalleRegla").className = document.getElementById("asideDetalleRegla").className.replaceAll(" hidden","") + " hidden"
    document.getElementById("nombreRegla").value = ""
  }
  
  function visibilidadModalFiltradoDatos(accion){

    if(accion === "abrir"){
      document.getElementById("detalleLateralFiltradoElementosReglas").className = document.getElementById("detalleLateralFiltradoElementosReglas").className.replaceAll(" hidden", "")      
    }
    else{
      document.getElementById("detalleLateralFiltradoElementosReglas").className = document.getElementById("detalleLateralFiltradoElementosReglas").className.replaceAll(" hidden", "") + " hidden"      
    }

  }
 
  return (    
    <>    
      <div className="modal-content full-width">
        <button className="link close" onClick={() => params.operarDetalleLateralPantallaCompleta("cerrar")}><span className="material-icon">highlight_off</span></button>
        <RulesList setObjRuleForm={setObjRuleForm} abrirNuevaRegla={params.abrirNuevaRegla} update={params.update} setObjRuleElementSelector={setObjRuleElementSelector}/> 
      </div>

      <aside id="asideDetalleRegla" className="modal lateral-detail rules hidden" onMouseDown={gestionarVisibilidadDetalleRegla}>

        <div className="modal-content">

          <button className="link close" onClick={() => cerrarMenuLateral()}><span className="material-icon">highlight_off</span></button>
          <div className="page">

            <section id="ruleForm" className=" " style={{paddingLeft: "-50px"}}>

              <div id="divFormularioRegla" className="content-wrapper">

                <header className="horizontal center gap-04">                                
                  <figure id="figureDetalleWidget" className="avatar size-xl">
                    <span id="iconoDetalleWidget" className="material-icon">engineering</span>
                  </figure>
                  <dl className="vertical fill">
                    <dd id="tituloDetalleRegla" className="headline-02"></dd>
                  </dl>
                </header>   

                {objRuleForm}
              
              </div>
              
            </section>

          </div>
          
        </div>

        <aside id="detalleLateralFiltradoElementosReglas" className="modal lateral-detail hidden">
          
          <div className="modal-content ">
              <button className="link close" onClick={() => visibilidadModalFiltradoDatos("cerrar")}>
                <span className="material-icon">highlight_off</span>
              </button>

              <div className="page">
                <header>
                  <h1 id="tituloListadoDatosAccionesReglas" className="headline-02"> </h1>
                </header>

                <div className="vertical gap-04">

                <fieldset id="cajaFiltradoElementosReglas">        
                  <fieldset className="search automatic">
                    <input type="search" id="searchElementosReglas" spellCheck="false" autoComplete="off" placeholder="Filtrar..." onKeyUp={() => rulesCommonJS.filtrarElementosSeleccionReglas()}/> 
                    <span className="material-icon icon-wrapper" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("searchElementosReglas","SELECCION_ELEMENTOS_REGLAS")}></span>
                  </fieldset>
                </fieldset>

                <section className="brands-list">
                  
                  <RulesElementSelectorList objRuleElementSelector={objRuleElementSelector} setObjRuleElementSelector={setObjRuleElementSelector} visibilidadModalFiltradoDatos={visibilidadModalFiltradoDatos}/>                      
                  
                </section>            
                
                </div> 
              </div>       
          </div>
        </aside>

      </aside>



    </>
  )
}

export default Rules